import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <main className="text-foreground relative flex min-h-dvh flex-col items-center justify-center gap-4 overflow-hidden px-4 text-center">
      <div
        aria-hidden
        className="pointer-events-none absolute top-1/2 left-1/2 size-[34rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,color-mix(in_oklab,var(--color-accent-neon)_16%,transparent),transparent_60%)] blur-2xl"
      />
      <div className="glass bezel animate-fade-in-up relative flex flex-col items-center gap-3 rounded-2xl border border-border/70 px-10 py-9">
        <Compass className="text-accent-neon size-10" aria-hidden />
        <h1 className="text-gradient font-mono text-6xl font-bold tracking-tight">404</h1>
        <p className="text-muted-foreground">No route matches.</p>
        <Button asChild className="mt-1">
          <Link to="/dashboard">Back to dashboard</Link>
        </Button>
      </div>
    </main>
  );
}
